export default {
  ACTIVE_ACCOUNT: "Active_Account",
  APPLIED: "Applied",
  APPROVED: "Approved",
  CANCELLED: "Cancelled",
  CLOSED: "Closed",
  DECLINED: "Declined",
  BLOCKED: "Blocked"
};
